import React from 'react';

export function FormField({ label, required, error, children }) {
  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>
      {children}
      {error && <p className="mt-1 text-xs text-red-600">{error}</p>}
    </div>
  );
}

export function TextInput({ value, onChange, placeholder, type = 'text', className = '', ...props }) {
  return (
    <input
      type={type}
      value={value}
      onChange={e => onChange(e.target.value)}
      placeholder={placeholder}
      className={`w-full border border-gray-300 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#1e3a5f] focus:border-transparent ${className}`}
      {...props}
    />
  );
}

export function SelectInput({ value, onChange, options, placeholder, className = '' }) {
  return (
    <select
      value={value}
      onChange={e => onChange(e.target.value)}
      className={`w-full border border-gray-300 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#1e3a5f] focus:border-transparent bg-white ${className}`}
    >
      {placeholder && <option value="">{placeholder}</option>}
      {options.map(opt => (
        <option key={opt.value ?? opt} value={opt.value ?? opt}>
          {opt.label ?? opt}
        </option>
      ))}
    </select>
  );
}

export function RadioGroup({ value, onChange, options }) {
  return (
    <div className="flex gap-4">
      {options.map(opt => (
        <label key={opt.value} className="flex items-center gap-2 cursor-pointer">
          <input
            type="radio"
            value={opt.value}
            checked={value === opt.value}
            onChange={() => onChange(opt.value)}
            className="accent-[#1e3a5f]"
          />
          <span className="text-sm text-gray-700">{opt.label}</span>
        </label>
      ))}
    </div>
  );
}

export function NavButtons({ onBack, onNext, nextLabel = 'Next', disabled = false, submitting = false }) {
  return (
    <div className="pt-6 space-y-3">
      <button
        onClick={onNext}
        disabled={disabled || submitting}
        className="w-full bg-[#1e3a5f] hover:bg-[#162d4a] disabled:bg-gray-300 text-white font-semibold py-3 rounded-xl transition-colors"
      >
        {submitting ? 'Submitting...' : nextLabel}
      </button>
      {onBack && (
        <button
          onClick={onBack}
          className="w-full text-gray-500 hover:text-gray-700 text-sm font-medium py-2 transition-colors"
        >
          ← Back
        </button>
      )}
    </div>
  );
}
